module.exports = __webpack_public_path__ + "img/nt111-07-85-1.prt.238b155f.jpg";